import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
// import './assets/css/theme-green/index.css'; // 浅绿色主题
import './assets/css/icon.css';
import './components/common/directives';
import 'babel-polyfill';
import {get,post,put,patch,del} from './utils/http'
import axios from 'axios'
import './assets/css/iconfont.js'
import './assets/css/iconfont.css'
import ElSelectTree from 'el-select-tree';
import '@/assets/css/style.scss'
import echarts from 'echarts'
import store from '../src/store/store'

//Ueditor富文本框组件
import VueUeditorWrap from 'vue-ueditor-wrap'
import '../static/UEditor/ueditor.config.js'
import '../static/UEditor/themes/default/css/ueditor.css'
import '../static/UEditor/ueditor.all.js'
import '../static/UEditor/lang/zh-cn/zh-cn.js'

Vue.component('vue-ueditor-wrap', VueUeditorWrap)


Vue.prototype.$echarts = echarts
Vue.prototype.$store = store

const Base64 = require('js-base64').Base64
Vue.use(ElSelectTree);

//定义全局变量封装axios的请求方法.
Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$put = put;
Vue.prototype.$patch = patch;
Vue.prototype.$del = del;
Vue.prototype.$base64 = Base64;

import JwChat from 'jwchat';
// 定义全局访问静态资源url
// const apiUrl = process.env.VUE_APP_URL

const apiUrl = 'https://crjyxspt.zikaoj.com'
// const apiUrl = 'http://127.0.0.1:8000'
// const apiUrl = 'http://crjypt.sikang.cc'
// const apiUrl = 'http://192.168.0.7:8088'
// const apiUrl = 'http://zkzj.sikang.cc'
// const apiUrl = 'https://ceshi.zikaoj.com:9088'


Vue.prototype.STATIC_URL =  apiUrl
//定义全局api url
Vue.prototype.BASEURL = apiUrl + '/api/v1'
// //定义文件上传的临时路径
Vue.prototype.FILE_TEMP_URL = apiUrl + '/api/v1/course/file/save'
// //定义模板文件的下载路径
Vue.prototype.QUESTION_TEMPLATE_URL = apiUrl + '/static/file/question/试题导入模板.xlsx'
// //定义模板文件的下载路径
Vue.prototype.COURSE_TUTION_TEMPLATE_URL = apiUrl + '/static/file/tution/课程开课导入模板.xlsx'


/*本地环境*/
 // Vue.prototype.STATIC_URL = 'http://192.168.0.106:9000'
 //定义全局api url
// Vue.prototype.BASEURL = 'http://192.168.0.106:9000/api/v1'
// // //定义文件上传的临时路径
//  Vue.prototype.FILE_TEMP_URL ='https://192.168.0.102:8000/api/v1/course/file/save'
// // //定义模板文件的下载路径
//  Vue.prototype.QUESTION_TEMPLATE_URL ='https://192.168.0.102:8000/static/file/question/试题导入模板.xlsx'
//  // //定义模板文件的下载路径
//   Vue.prototype.COURSE_TUTION_TEMPLATE_URL ='https://192.168.0.102:8000/static/file/tution/课程开课导入模板.xlsx'
// /*开发环境*/
// Vue.prototype.STATIC_URL = 'https://zkxxxt.zikaoj.com'// //定义全局api url
// Vue.prototype.BASEURL = 'https://zkxxxt.zikaoj.com/api/v1'
// //定义文件上传的临时路径
// Vue.prototype.FILE_TEMP_URL ='https://zkxxxt.zikaoj.com/api/v1/course/file/save'
// //定义模板文件的下载路径
// Vue.prototype.QUESTION_TEMPLATE_URL ='https://zkxxxt.zikaoj.com/static/file/question/试题导入模板.xlsx'
//  //定义模板文件的下载路径
// Vue.prototype.COURSE_TUTION_TEMPLATE_URL ='https://zkxxxt.zikaoj.com/static/file/tution/课程开课导入模板.xlsx'


Vue.prototype.Base64 = require('js-base64').Base64
/*post请求例子
this.$post(
    this.BASEURL+'/account/register',
    {'account':'admin','password':'123456'}).then((res)=>{
    console.log(res.msg)
});
*/



Vue.config.productionTip = false;
Vue.use(ElementUI, {
    size: 'small'
});

axios.interceptors.request.use(
    config => {
        if (localStorage.my_token) {  // 判断是否存在token，如果存在的话，则每个http header都加上token
            config.headers.Authorization = `${localStorage.my_token}`;
        }
        return config;
    },
    err => {
        return Promise.reject(err);
    });



// //使用钩子函数对路由进行权限跳转
// router.beforeEach((to, from, next) => {
//     document.title = `${to.meta.title} | vue-manage-system`;
//     const role = localStorage.getItem('ms_username');
//     if (!role && to.path !== '/login') {
//         next('/login');
//     } else if (to.meta.permission) {
//         // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
//         role === 'admin' ? next() : next('/403');
//     } else {
//         // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
//         if (navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor') {
//             Vue.prototype.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
//                 confirmButtonText: '确定'
//             });
//         } else {
//             next();
//         }
//     }
// });
router.beforeEach((to, from, next) => {
    window.document.title = to.meta.title == undefined?'默认标题':to.meta.title
    // if (to.meta.requireAuth) {
    //     let token = Cookies.get('access_token');
    //     let anonymous = Cookies.get('user_name');
    //     if (token) {
    //         next({
    //             path: '/login',
    //             query: {
    //                 redirect: to.fullPath
    //             }
    //         })
    //     }
    // }
    next()
})


new Vue({
    router,
    render: h => h(App)
}).$mount('#app');
